// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useTranslation } from 'react-i18next';
import { normalizeNumber } from 'util/commons';
import styles from './CollectRouteSummary.module.scss';
import BigNumber from 'bignumber.js';

type SumaryProps = {
  quantity: number | string | BigNumber;
  weight: number | string | BigNumber;
};

const CollectRouteSummary = ({ quantity, weight }: SumaryProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.overall}>
      <div className={styles.quantity}>
        <div className={styles.quantityTitle}>
          {t('confirm_visit_list.overall.estimated_quantity')}
        </div>
        <div className={styles.quantityContent}>
          <div className={styles.quantityNumber}>
            {normalizeNumber({ value: quantity })}
          </div>
          <div className={styles.unit}>
            {t('confirm_visit_list.overall.quantity_unit')}
          </div>
        </div>
      </div>
      <div className={styles.weight}>
        <div className={styles.weightTitle}>
          {t('confirm_visit_list.overall.estimated_weight')}
        </div>
        <div className={styles.weightContent}>
          <div className={styles.weightNumber}>
            {normalizeNumber({ value: weight })}
          </div>
          <div className={styles.unit}>kg</div>
        </div>
      </div>
    </div>
  );
};

export default CollectRouteSummary;
